import { Component, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
@Component({ template: '' })
export class Direct {
  queryParams: { key: string, value: string }[] = [];

  constructor(private router: Router) {    
    let queryParams = this.router.parseUrl(this.router.url).queryParams;    
    Object.keys(queryParams).forEach(key => {
      this.queryParams.push({ key: key, value: queryParams[key] });
    });

    if (!localStorage.getItem('qx_userId') || !localStorage.getItem('qx_username')) window.location.href = '/signin';
    if (this.queryParams[0].key == 'view') {            
      localStorage.setItem('qx_direct', JSON.stringify({nodeId: this.queryParams[0].value, lineId: this.queryParams[1] ? this.queryParams[1].value : undefined}));
      this.router.navigate(['base']);      
    }
    
    if (this.queryParams[0].key == 'report') {
      localStorage.setItem('qx_report', JSON.stringify({reportId: this.queryParams[0].value, lineId: this.queryParams[1] ? this.queryParams[1].value : undefined}));      
      this.router.navigate(['report-viewer']);
    }
    
    if (this.queryParams[0].key == 'dashboard') {
      localStorage.setItem('qx_dashboard', JSON.stringify({dashboardId: this.queryParams[0].value, refreshInterval: '250'}));      
      this.router.navigate(['dashboard-viewer']);
    }

    if (this.queryParams[0].key == 'enabledirect') {
      localStorage.setItem('qx_directFromExisting', JSON.stringify({nodeId: this.queryParams[1].value}));
      this.router.navigate(['base']);   
    }
  }
}